export default "__VITE_ASSET__DvtuHrk0__"